jQuery(function( $ ) {
	'use strict'

	// An object that handles the display of a warning modal

    window.WarningModalManager = {

        defaultTitle        : 'Warning',
        defaultMessage 	    : 'A serious error occurred.',
        defaultButtonText 	: 'OK',

        modal               : $( '#modal-warning' ),
		confirmationButton  : $( '#modal-warning .btn-confirm' ),

        callback            : null,

        show : function( { title, message, buttonText, callback } ) {
            this.title      = title        ? title        : this.defaultTitle;
            this.message    = message      ? message      : this.defaultMessage;
            this.buttonText = buttonText   ? buttonText   : this.defaultButtonText;
            this.callback   = callback     ? callback     : this.defaultCallback;

            this.modal.find( '.modal-title' ).text( title );
            this.modal.find( '.message' ).html( message );
            this.confirmationButton.text( buttonText );

            this.confirmationButton.off( 'click' );
            this.confirmationButton.on( 'click', window.WarningModalManager.submit );
            this.modal.modal();
        },

		submit : function() {
			window.WarningModalManager.modal.modal( 'hide' );
			if ( window.WarningModalManager.callback ) {
				window.WarningModalManager.callback();
			}
		}

    };

});
